import React, { useEffect, useState } from 'react'
import FadedLineHeader from '../../common/components/fadedLineHeader/FadedLineHeader'
import UTile from './unified/UTile'
import { PanwLogo } from '../assets'
import SubscriptionService from '../services/SubscriptionService'
import type { VFC } from 'react'

const ActivationTilePage: VFC<any> = (props) => {
  const { globalTsgId, auth } = props
  const [showTite, setShowTite] = useState<boolean>(false)
  const [deploymentProfiles, setDeploymentProfiles] = useState<any>([])
  useEffect(() => {
    async function fetchData() {
      const { data } = await SubscriptionService.deploymentProfiles.getForUser(globalTsgId, auth.user.email)
      setDeploymentProfiles(data)
      setShowTite(Boolean(data?.totalProfiles))
    }
    fetchData()
  }, [globalTsgId, auth.user.email])
  if (showTite) {
    return (<div style={{ maxWidth: '1248px' }}>
      <FadedLineHeader title="Ready for activation" />
      <div className='cm-justify-ceneter cm-mb-8 cm-px-8'>
        <UTile product_image={PanwLogo} product_title={'VM-Series'} action={() => window.location.href = '/activation/profile'} action_text='Activate Now' subtitle='Activate Subscriptions based on Deployment Profile(s)' product_attributes={{ 'Quantity': `${deploymentProfiles?.totalProfiles} Deployment Profiles` }}></UTile>
      </div>
    </div>)
  }
  return (<></>
  )
}

export default ActivationTilePage
